// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"783":"sites","6842":"map","6865":"legacySearch"}[chunkId] || chunkId) + "." + {"783":"36603d0a","2896":"1cec202f","6842":"f7a8ae67","6865":"f7a8ae67","9361":"a124fcf9"}[chunkId] + ".css";
};